import React, { useEffect } from "react";
import { useParams } from "react-router";

import useAPI from "services/Api";
import Page from "pages/Page";
import { navigate } from "utility/NavigationService";
import { renderLoader } from "utility/LoaderUtils";
import { useNotificationManager } from "notifications/NotificationManager";

const ValidateEmail = ({ componentName = "[ValidateEmail]" }) => {
    const key = useParams().key;
    const API = useAPI();
    const notificationManager = useNotificationManager();

    // ---=== KarunaCLOUD ===--- //

    const performValidateEmail = async (keyVal) => {
        await API.api_Get(
            componentName,
            `/verify-email/${keyVal}/`,
            notificationManager,
            (response) => {
                if (response.status >= 400) {
                    throw new Error("Sorry, a bad request meant we could not find your email or account. Please try again or contact a Karuna Admin.");
                }

                let url = response.data.reset_url;
                if (url === undefined) {
                    throw new Error("Sorry, you have already set a password or this link has already been used.");
                }

                void navigate("/password/" + url);
            },
            (error) => {
                console.error(error);
                if (error.response === undefined) {
                    notificationManager.addError(error);
                }
                else {
                    notificationManager.addError(error.response?.data);
                }
            }
        );
    };

    // ---=== Render ===--- //

    useEffect(
        () => {
            if (key) {
                console.log(key);
                void performValidateEmail(key);
            }
        },
        []
    );

    return (
        <Page
            componentName={componentName}
            internal={false}
        >
            {
                !notificationManager.hasErrors()
                    ? (
                        renderLoader()
                    )
                    : (
                        <div className="h-screen flex items-center justify-center pb-12">
                            <div className="w-96 h-56 flex-col justify-start items-center gap-8 inline-flex">
                                <div className="self-stretch h-44 flex-col justify-start items-center gap-6 flex">
                                    <div className="w-14 h-14 p-3.5 bg-rose-100 rounded-full border border-gray-50 justify-center items-center inline-flex">
                                        <img src="/icons/link-broken-01.svg" className="w-7 h-7 relative flex-col justify-start items-start flex" alt="Broken Link Icon"/>
                                    </div>
                                    <div className="self-stretch h-24 flex-col justify-start items-start gap-3 flex">
                                        <div className="self-stretch text-center text-gray-900 text-3xl font-semibold leading-9">Authentication Error</div>
                                        <div className="self-stretch text-center text-gray-600 text-base font-normal leading-normal">Sorry, we could not authenticate your email address. Please contact a Karuna administrator.</div>
                                    </div>
                                </div>
                                <a href="/src/pages/Login">
                                    <div className="justify-center items-center gap-1.5 inline-flex">
                                        <img className="w-5 h-5" src="/icons/arrow-left.svg" alt="Left Arrow"/>
                                        <div className="text-gray-600 text-sm font-semibold leading-tight">Go to Sign In</div>
                                    </div>
                                </a>
                            </div>
                        </div>
                    )
            }
        </Page>
    );
};

export default ValidateEmail;
